import React from 'react';
import { FaExclamationTriangle, FaClock } from 'react-icons/fa';

const InactivityWarning = ({ showWarning, handleContinue, handleLogout }) => {
  if (!showWarning) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex-shrink-0">
            <FaExclamationTriangle className="h-8 w-8 text-orange-500" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Session Timeout Warning
            </h3>
            <p className="text-sm text-gray-600">
              You will be logged out in 30 seconds due to inactivity
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2 mb-6 p-3 bg-orange-50 rounded-lg">
          <FaClock className="h-5 w-5 text-orange-500" />
          <span className="text-sm font-medium text-orange-800">
            Click "Continue Session" to stay logged in
          </span>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={handleContinue}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Continue Session
          </button>
          <button
            onClick={handleLogout}
            className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors font-medium"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;
